import { PATH } from 'data';

export const __PanelNoMenuRoutes = [
    PATH.panel.addPost.index(),
    PATH.panel.editPost(),
    PATH.panel.chat(),
    PATH.panel.myAdsPreView(),
];
